<!-- 学科信息详情 -->
<template>
  <div id='subjectPage' class="flex-w">
    <div class="left">
      <h5>说明</h5>
      <p>请确认学校招生的年级、学科、版本。如有疑问，请联系未来魔法校学科老师。</p>
    </div>
    <div class="right">
      <app-title>请确认信息</app-title>
      <app-detail v-for="(item, index) in title" :title="title" :key="index" :index="index" :detail="detail"></app-detail>
      <button class="app-btn" :class="{'disabled':this.status===2}" @click="goComfirm">确认</button>
    </div>
  </div>
</template>

<script>
import api from '@/services/server.js'
import { getGrade, getVersion } from '@/utils/filter.js'
export default {
  data () {
    return {
      id: this.$route.query.id,
      status: Number(this.$route.query.status),
      title: [{ key: 'subject', value: '学科' }, { key: 'grade', value: '年级' }, { key: 'version', value: '版本' }],
      detail: {}
    }
  },
  components: {},
  created () {
    this.getData()
  },
  methods: {
    getData () {
      let params = {
        school_id: this.id
      }
      api.subject(params).then(res => {
        if (res.ok) {
          this.detail = res.data
          this.detail.grade = getGrade(this.detail.grade)
          this.detail.version = getVersion(this.detail.version)
        }
      })
    },
    goComfirm () {
      if (this.status !== 2) {
        let params = {
          school_id: this.id
        }
        api.confirm(params).then(res => {
          if (res.ok) {
            this.$message({
              type: 'success',
              message: '确认成功!'
            })
            this.$router.back()
          }
        })
      }
    }
  }
}
</script>
<style scoped lang='scss'>
#subjectPage {
  div {
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
  }
  .left {
    width: 260px;
    height: 157px;
    text-align: left;
    padding: 29px 35px 29px 29px;
    margin-right: 20px;
    h5 {
      margin-bottom: 19px;
      font-size: 16px;
    }
    p {
      color: #666;
      font-size: 14px;
      line-height: 22px;
    }
  }
  .right {
    width: 900px;
    height: 290px;
    box-shadow: 0px 8px 32px 0px rgba(238, 238, 238, 0.6);
    margin-bottom: 54vh;
    padding: 32px 30px 60px;
    button {
      margin-top: 60px;
    }
    .disabled {
      cursor: not-allowed;
      opacity: 0.7;
    }
  }
}
</style>
